import { TextField, TextArea } from '@lavu-pos/lavu-react-components';
import {
	RadioGroup,
	TextField as StellarTextField,
	AutoComplete,
	Checkbox,
	ToggleButtonsGroup,
	Tabs,
} from '@lavu-pos/stellar';
import formikConnector from './FormikConnector';
import FormikTimePicker from './FormikTimePicker';

// React-components inputs
export const FormikTextField = formikConnector(TextField);
export const FormikTextArea = formikConnector(TextArea);

// Stellar inputs
export const FormikRadioGroup = formikConnector(RadioGroup);
export const FormikStellarTextField = formikConnector(StellarTextField);
export const FormikAutoComplete = formikConnector(AutoComplete);
export const FormikCheckbox = formikConnector(Checkbox);
export const FormikToggleButtonsGroup = formikConnector(ToggleButtonsGroup);
export const FormikTabs = formikConnector(Tabs);
export { formikConnector, FormikTimePicker };
